import { Skeleton } from "@/components/ui/skeleton";

/**
 * The app-wide route placeholder: a shape that matches a typical page header
 * plus its first block. Extracted from App.tsx so route-level guards can show
 * the same thing while a session or a role resolves, instead of a blank screen
 * or a second, subtly different skeleton.
 */
export const PageLoader = () => (
  <div className="container py-12 space-y-4">
    <Skeleton className="h-8 w-48" />
    <Skeleton className="h-64 w-full rounded-xl" />
    <Skeleton className="h-4 w-3/4" />
  </div>
);

export default PageLoader;
